import {Component, Input} from '@angular/core';
import {EstadoOnboardingPainel} from '../onboarding-painel.service';

/**
 * Prêmio por concluir os primeiros passos: R$ 25 de desconto na primeira mensalidade, se o pedido de teste for
 * concluído dentro do teste grátis. Destaque no hub, faixa no alto de cada passo, reforço no botão de concluir.
 * Prazo vencido sem garantir: some (não promete o que não vale mais).
 */
@Component({
  selector: 'app-onb-bonus',
  templateUrl: './onb-bonus.component.html',
  styleUrls: ['./onb-bonus.component.scss']
})
export class OnbBonusComponent {
  @Input() estado: EstadoOnboardingPainel;
  @Input() formato: 'destaque' | 'faixa' | 'final' = 'destaque';

  get bonus(): any { return this.estado?.bonus || null; }

  get garantido(): boolean { return !!this.bonus?.garantido; }

  get visivel(): boolean { return !!this.bonus && (this.bonus.garantido || this.bonus.disponivel); }

  get valor(): string { return `R$ ${Number(this.bonus?.valor || 25).toFixed(0)}`; }

  get prazo(): string {
    const p = this.bonus?.prazo;
    return p ? new Date(p).toLocaleDateString('pt-BR', {day: '2-digit', month: '2-digit'}) : '';
  }

  get dias(): number {
    const p = this.bonus?.prazo ? new Date(this.bonus.prazo).getTime() : 0;
    return p ? Math.max(0, Math.ceil((p - Date.now()) / 86400000)) : 0;
  }

  get textoDias(): string {
    if (!this.prazo) return '';
    if (this.dias <= 0) return `até hoje (${this.prazo})`;
    return `até ${this.prazo} · ${this.dias === 1 ? 'falta 1 dia' : 'faltam ' + this.dias + ' dias'}`;
  }

  get faltam(): number { return Math.max(0, (this.estado?.total || 6) - (this.estado?.feitos || 0)); }

  get textoFaltam(): string {
    if (!this.faltam) return 'Tudo pronto: conclua o pedido de teste';
    return this.faltam === 1 ? 'Falta 1 passo' : `Faltam ${this.faltam} passos`;
  }
}
